import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../common';
import { ShipmentTransportOrderOuterPackagesResponseModel } from '../../models/shipment-transport-order-outer-packages.model';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { TransportOrderIdView } from '../../../../models';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderOuterPackagesService {
  constructor(private http: WrapperHttpService) {}

  getOuterPackages(
    transportOrderIdView: TransportOrderIdView,
  ): Observable<ShipmentTransportOrderOuterPackagesResponseModel> {
    return this.http
      .withLoading()
      .get<ShipmentTransportOrderOuterPackagesResponseModel>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.OuterPackages
        }?${getQueryStringFromObject(transportOrderIdView)}`,
      );
  }
}
